import React from 'react';
import PropTypes from 'prop-types';
import { Loader } from 'lucide-react';

const PrimaryButton = ({ onClick, text, icon: Icon, width, height, color, isLoading }) => {
    return (
        <button
            onClick={onClick}
            style={{
                width: width || '74px',
                height: height || '36px',
                padding: '2px 3px',
                gap: '8px',
                borderRadius: '6px',
                backgroundColor: color || '#002D72',
                color: '#FFFFFF',
                fontSize: '14px',
                fontWeight: 'bold',
                opacity: isLoading ? '0.7' : '1',
                cursor: isLoading ? 'not-allowed' : 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: 'none',
                position: 'relative',
            }}
            disabled={isLoading}
        >
            {isLoading ? (
                <Loader size={16} className="animate-spin" />
            ) : (
                <>
                    {Icon && <Icon size={16} style={{ marginRight: '8px' }} />}
                    {text}
                </>
            )}
        </button>
    );
};

PrimaryButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
    icon: PropTypes.elementType,
    width: PropTypes.string,
    height: PropTypes.string,
    color: PropTypes.string,
    isLoading: PropTypes.bool,
};

export default PrimaryButton;
